import { WitaConnector } from '@/services/repository/connector'

import { Repo } from './CallTech.d'

const ROOT_URL = '/entity/call-tech'

export const CallTechRepository = {
  FindById: async ({ callId }: Repo.CallTech.FindById.Params) => {
    const url = ROOT_URL + `/${callId}`
    return await WitaConnector.get<Repo.CallTech.FindById.Response>(url)
  },

  Create: async (params: Repo.CallTech.Create.Params) => {
    const url = ROOT_URL
    return await WitaConnector.post<Repo.CallTech.Create.Response>(url, params)
  },

  Edit: async ({ callId, ...params }: Repo.CallTech.Edit.Params) => {
    const url = ROOT_URL + `/${callId}`
    return await WitaConnector.put<Repo.CallTech.Edit.Response>(url, params)
  },
}
